<h1>{{ "ADMIN.ADMIN" | appString }}</h1>

<div>
  <button
    routerLink="/admin/edit-trial"
    (click)="uploadTrialInsertion()"
    >
    {{ "ADMIN.UPLOADFILEFORTRIAL" | appString }}
  </button>
</div>


<h2>{{ "GENERAL.TRIALS" | appString }} </h2>
<div>
  <mat-form-field>
    <mat-label>{{ "GENERAL.FILTER" | appString }}</mat-label>
    <input matInput (keyup)="applyFilter($event)" #input>
  </mat-form-field>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="trialNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{ headerStyle: true }">{{ "GENERAL.TRIALNUMBERSHORT" | appString }}</th>
      <td class="status-complete" mat-cell *matCellDef="let row"> {{row.trialNumber}} </td>
    </ng-container>

    <ng-container matColumnDef="insertionDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{ headerStyle: true }"> {{ "GENERAL.INSERTION" | appString }} </th>
      <td [ngClass]="isCompleted(row.insertionDate) ? 'status-complete': ''" mat-cell *matCellDef="let row">{{row.insertionDate | date: 'dd.MM.yy'}}</td>
    </ng-container>

    <!-- <ng-container matColumnDef="firstWeighing">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> 1. Mellemvejning </th>
      <td [ngClass]="isCompleted(row.firstWeighing.status) ? 'status-complete': ''" mat-cell *matCellDef="let row"> {{row.firstWeighing.text}} </td>
    </ng-container>

    <ng-container matColumnDef="secondWeighing">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> 2. Mellemvejning </th>
      <td [ngClass]="isCompleted(row.secondWeighing.status) ? 'status-complete': ''" mat-cell *matCellDef="let row"> {{row.secondWeighing.text}} </td>
    </ng-container> -->

    <ng-container matColumnDef="endDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{ headerStyle: true }">{{ "GENERAL.ENDDATE" | appString }}</th>
      <td [ngClass]="isCompleted(row.endDate) ? 'status-complete': ''" mat-cell *matCellDef="let row"> {{row.endDate | date: 'dd.MM.yy'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="rowClick(row.id)"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">{{ "GENERAL.NODATAMATCHESFILTER" | appString }} "{{input.value}}"</td>
    </tr>
  </table>

  <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Side" ></mat-paginator>
</div>
